import React from 'react';
import {connect} from 'react-redux';

import {fetchListings} from '../../../actions/listings';

export function onRetry(dispatch, segmentKey) {
    return () => {
        dispatch(fetchListings(segmentKey));
    };
}

export function mapStateToProps(state) {
    return {
        segmentKey: state.destination.segmentFilters.key,
        heading: state.modules.retryCard.heading,
        text: state.modules.retryCard.text,
        button: state.modules.retryCard.button
    };
}

export function RetryCardComponent({
    dispatch,
    segmentKey,
    heading,
    text,
    button
}) {
    return (
        <div className="great-places-retry-card">
            <h3>{heading}</h3>
            <p>{text}</p>
            <button className="btn btn-sm btn-default" onClick={onRetry(dispatch, segmentKey)}>
                {button}
            </button>
        </div>
    );
}

export const RetryCard = (connect(mapStateToProps)(RetryCardComponent));
